import React, { useState, useCallback, useMemo } from "react";
import Label from "lib/Label";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
const SingleSelectDropdown = (props) => {
  const {
    name,
    error,
    options,
    onChange,
    validators,
    question,
    title,
    id,
    questionnaireId,
    content,
    riskProfile,
  } = props;
  const questionData = useSelector((state) => state.formData?.questionData);
  const [selectedOption, setSelectedOption] = useState(null);
  const errorClass = useMemo(
    () => (error?.length ? "error_outline" : ""),
    [error]
  );
  const handleSelectChange = useCallback(
    (option) => {
      setSelectedOption(option);
      if (onChange) {
        onChange(
          option.label,
          question,
          id,
          questionnaireId,
          content,
          option.id,
          option.score,
          name
        );
      }
    },
    [onChange, id, question, questionnaireId, name, content]
  );
  const IndirectEval = (item) => {
    return eval(item);
  };
  const answers = useMemo(() => {
    const filteredItems = questionData.filter(
      (item) => item.question_id === id
    );
    const answersList = filteredItems.map((item) => item.answer);
    return answersList.length > 0 ? answersList[0] : null;
  }, [questionData, id]);
  return (
    <div
      className={`${
        riskProfile ? `bg-body-tertiary` : ` ${errorClass}`
      } border border-secondary rounded p-3 py-4 mt-4`}
    >
      <p className="mb-0 fs-12px text-secondary">{title}</p>
      <Label
        className="question_label text-secondary"
        label={question}
        validators={validators}
      />
      {content ? (
        <div
          className="table table-responsive"
          dangerouslySetInnerHTML={{ __html: IndirectEval(content) }}
        />
      ) : (
        content
      )}
      <Dropdown
        className={`${errorClass} border border-theme rounded `}
        drop="down-centered"
      >
        <Dropdown.Toggle
          disabled={riskProfile}
          id="dropdown-autoclose-outside"
          className={`bg-white border-0 text-black text-start w-100 d-flex align-items-center justify-content-between`}
        >
          <p
            className={`mb-0 fs-15px ${
              answers ? "text-truncate w-75" : "w-100"
            }`}
          >
            {answers ? answers : "Select an option"}
          </p>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 7.605 4.302"
              class=""
            >
              <path
                id="Path_8068"
                data-name="Path 8068"
                d="M0,0,3.1,3.1,0,6.191"
                transform="translate(6.898 0.707) rotate(90)"
                fill="none"
                stroke="#343a40"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                opacity="0.995"
              ></path>
            </svg>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={`max-w-0 w-100 ${
            options.length > 10
              ? "h-350px theme-scrollbar-hover overflow-y-scroll"
              : ""
          }`}
        >
          {options.map((option) => {
            const { id, label } = option;
            return (
              <Dropdown.Item
                key={id}
                onClick={() => handleSelectChange(option)}
                className="bg-active-grey d-flex align-items-center"
              >
                <label htmlFor={`${name}${id} `} className="ms-2 mt-1">
                  {label}
                </label>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      {error?.length > 0 && <ErrorMessage error={error} />}
    </div>
  );
};
export default SingleSelectDropdown;